import React from "react";
import DPTable, { Header } from "Components/DP/DPTable/DPTable";
import { DPEmployeeDisbursement } from "Shared/types/Disbursements";
import { DPComponentLoader, DPEmptyTable } from "Components/DP";
import EmployeeDisbursementTableRow from "./EmployeeDisbursementTableRow/EmployeeDisbursementTableRow";
import useDisbursements from "../Hooks/useDisbursementsHook";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

const ActionColumn = {
  header: {
    label: "Action",
    align: "center",
  } as Header,
  width: 15,
};

const defaultDisbursementColumns = [
  { header: "Submitted At", width: 12 },
  { header: "Date Received", width: 15 },
  { header: "Bank", width: 15 },
  { header: "Amount", width: 9 },
  { header: "Reason", width: 9 },
  { header: "Notes", width: 15 },
  { header: "Status", width: 10 },
];

type DisbursementTableProps = {
  employeeProfileId: string;
};

const EmployeeDisbursementTable = ({ employeeProfileId }: DisbursementTableProps) => {
  const { data, loading, page, setPage, rowsPerPage, refetchQueries } = useDisbursements(
    employeeProfileId
  );

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  const { offCyclePaymentOptions } = usePartnerConfig();

  const visibleDisbursementColumns = offCyclePaymentOptions.cycleRequiresApproval
    ? [...defaultDisbursementColumns, ActionColumn]
    : defaultDisbursementColumns;

  const colWidths = visibleDisbursementColumns
    .map(({ width }) => width);
  const headers = visibleDisbursementColumns
    .map(({ header }) => header);

  return (
    <DPTable
      colWidths={colWidths}
      count={data?.employeeProfile.disbursements.totalCount}
      headers={headers}
      {...data}
      page={page}
      rowsPerPage={rowsPerPage}
      onChangePage={handlePageChange}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          data?.employeeProfile.disbursements.items.length ? (
            <>
              {data.employeeProfile.disbursements.items.map(
                (disbursement: DPEmployeeDisbursement, idx: number) => (
                  <EmployeeDisbursementTableRow
                    onAlreadyReviewed={refetchQueries}
                    key={idx}
                    disbursement={disbursement}
                    showDisbursmentActionColumn={offCyclePaymentOptions.cycleRequiresApproval}
                  />
                )
              )}
            </>
          ) : (
            <DPEmptyTable message={"Disbursements will appear here"} />
          )
        }
      />
    </DPTable>
  );
};

export default EmployeeDisbursementTable;
